import { combineReducers } from "redux-immutable";
import { IntegrationSystem } from "../types";
import { BrevoSystem, brevoIntegrationReducer } from "./brevo";
import { CleverReachSystem } from "./cleverreach";
import { KlaviyoSystem, klaviyoIntegrationReducer } from "./klaviyo";
import { ShopwerkSystem, shopwerkIntegrationReducer } from "./shopwerk";
import { MailchimpSystem } from "./mailchimp";
import { Newsletter2GoSystem } from "./newsletter2go";
import { OmniletterSystem } from "./omniletter";
import { RapidmailSystem } from "./rapidmail";

export const INTEGRATION_SYSTEMS: IntegrationSystem[] = [
  MailchimpSystem,
  CleverReachSystem,
  Newsletter2GoSystem,
  RapidmailSystem,
  OmniletterSystem,
  BrevoSystem,
  KlaviyoSystem,
  ShopwerkSystem
];

export const integrationsReducer = combineReducers({
  brevo: brevoIntegrationReducer,
  klaviyo: klaviyoIntegrationReducer,
  shopwerk: shopwerkIntegrationReducer
});
